import { render, staticRenderFns } from "./CardMentoringIcon.vue?vue&type=template&id=7f954f9f&scoped=true&"
import script from "./CardMentoringIcon.vue?vue&type=script&lang=js&"
export * from "./CardMentoringIcon.vue?vue&type=script&lang=js&"
import style0 from "./CardMentoringIcon.vue?vue&type=style&index=0&id=7f954f9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f954f9f",
  null
  
)

export default component.exports